import React from 'react';
import { Reveal } from './Reveal';
import { TornEdge } from './TornEdge';
const CHAMAN_IMAGE = 'https://cdn.magicpatterns.com/uploads/5Z4mmv3vNWLkV7bYWhD3qe/freepik__mexican-spiritual-master-middleaged-with-a-serene-__38705.jpg';
export function MaestroJohn() {
  return <section aria-labelledby="maestro-title" className="relative bg-plum-deep py-16 sm:py-20" data-id="element-126" data-mp="1b51byolmtfec">
      <TornEdge colorClassName="bg-plum-deep" data-id="element-127" data-mp="28si6u1ijrbms" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-128" data-mp="28s9s042v5w8y">
        <Reveal stamp data-id="element-129" data-mp="23uqcz1ycdffy">
          <div className="flex flex-col items-center gap-9 border-2 border-gold/70 bg-ink/70 p-7 text-center shadow-gold sm:flex-row sm:items-center sm:gap-12 sm:p-12 sm:text-left" data-id="element-130" data-mp="23u86lchytkub">
            <div className="relative w-full max-w-[16rem] shrink-0 bg-paper p-2.5 shadow-paper sm:w-60" data-id="element-131" data-mp="1tuhflksm5nyz">
              <img src={CHAMAN_IMAGE} alt="Maestro John, chamán mayor del templo, frente a un altar con velas encendidas, cristales y un libro abierto" className="block aspect-[3/4] w-full object-cover" loading="lazy" data-id="element-132" data-mp="ng89saef2bba" />
              <p className="mt-2.5 text-center font-folio text-[0.58rem] uppercase tracking-[0.18em] text-ink/70" data-id="element-133" data-mp="m612wkhrgsef">
                Ficha 001 · Chamán mayor
              </p>
            </div>

            <div data-id="element-134" data-mp="c84onjtj1hc3">
              <span className="font-folio text-[0.62rem] uppercase tracking-[0.3em] text-gold" data-id="element-135" data-mp="c7lbshiqhj4x">
                Chamán mayor
              </span>
              <h2 id="maestro-title" className="mt-4 font-display text-3xl font-light uppercase tracking-[0.08em] text-paper sm:text-4xl" data-id="element-136" data-mp="387z7fzbcefz">
                Maestro John
              </h2>
              <span aria-hidden="true" className="mt-5 block h-px w-24 bg-gold/50" data-id="element-137" data-mp="3poubeivomr1q" />
              <p className="mt-6 text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-138" data-mp="3bqe52t1qf2k4">
                Nuestro chamán mayor, Maestro John, participa en consultas y
                prácticas tradicionales desde una perspectiva espiritual y
                personalizada.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}